import styled from "styled-components";
import { Button } from "antd";

export const HomePageContainer = styled.div`
  width: 100%;
  height: 94vh;
  background: #fcfcfc;
  padding-inline: 82px;
  padding-top: 40px;
  overflow-y: auto;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;

  ::-webkit-scrollbar {
    width: 4px;
    background-color: #fcfcfc;
  }
  ::-webkit-scrollbar-thumb {
    background: #11a7d9;
    border-radius: 1ex;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }
  ::-webkit-scrollbar-corner {
    background: #11a7d9;
  }
`;

export const SectionsContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  gap: 20px;
  align-items: stretch;
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: ${(props) => (props.hasManual ? "400px" : "605px")};
  border: 1px solid rgba(244, 244, 245, 1);
  background: #fff;
  border-radius: 6px;
  align-items: stretch;
  gap: 10px;
  padding: 24px;
  width: 100% !important;
`;

export const SectionHeaderTitle = styled.h1`
  margin: 0;
  font-family: Open Sans;
  font-weight: 700;
  font-size: 18px;
  color: rgba(10, 95, 124, 1);
`;

export const SectionSubHeader = styled.h2`
  font-family: Open Sans;
  font-weight: 700;
  font-size: 14px;
  color: rgba(17, 167, 217, 1);
`;

export const HeaderWithIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const ChecklistHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ActionButton = styled(Button)`
  &.ant-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 32px;
    padding: 0 12px;
    background: rgba(17, 167, 217, 1);
    border-radius: 6px;
    border: none;
    color: #fff;
    font-family: Open Sans;
    font-weight: 400;
    font-size: 14px;
    line-height: 1;
    box-shadow: none;
  }

  &.ant-btn:hover,
  &.ant-btn:focus {
    background: rgba(17, 167, 217, 0.85);
    color: #fff;
    border: none;
  }

  &.ant-btn:active {
    background: rgba(17, 167, 217, 0.7);
    color: #fff;
  }
`;

export const DatesContainer = styled.div`
  width: 278px;
  min-width: 278px;
  flex-shrink: 0;
`;

export const DatesGrid = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding-inline: 10px;
  gap: 10px;
`;

export const DatesRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const DatesDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;
`;

export const ToDoImage = styled.img`
  width: 100%;
  max-width: 279px;
  height: auto;
`;

export const ManualIcons = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

export const ChecklistContainer = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${(props) => (props.hasChecklist ? "10px" : "0")};
  justify-content: ${(props) => (props.hasChecklist ? "flex-start" : "center")};
  min-width: 0;
`;

export const ChecklistInfoTitle = styled.h3`
  margin-top: 16px;
  font-family: Open Sans;
  font-weight: 600;
  font-size: 16px;
  color: rgba(10, 95, 124, 1);
`;

export const ChecklistInfoDescription = styled.p`
  width: 100%;
  max-width: 70%;

  text-align: center;

  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;

  color: rgba(39, 39, 42, 1);

  align-self: center;
`;

export const ManualSectionCard = styled.div`
  width: 100%;
  height: 187px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  margin-top: 18px;
  padding-inline: 46px;
  display: flex;
  align-items: center;

  &::before {
    content: "";
    position: absolute;
    inset: 0;

    background: radial-gradient(
        70% 90% at 0% 50%,
        rgba(17, 167, 217, 0.18) 0%,
        rgba(17, 167, 217, 0) 100%
      ),
      radial-gradient(
        45% 80% at 100% 50%,
        rgba(17, 167, 217, 0.14) 0%,
        rgba(17, 167, 217, 0) 100%
      );

    z-index: 1;
  }

  > div {
    position: relative;
    z-index: 2;
  }
`;

export const ManualTitle = styled.h3`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: rgba(0, 34, 68, 1);
  margin: 0;
`;

export const ManualSubtitle = styled.p`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.88);
  max-width: 602px;
  @media (max-width: 1480px) {
    width: 298px;
  }
`;

export const ManualLabel = styled.p`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: rgba(17, 167, 217, 1);
  margin: 0;
`;

export const SectionHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
`;

export const ProductsAndProvidersTitle = styled.h3`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 20px;
  line-height: 18px;
  color: rgba(0, 34, 68, 1);
`;

export const SectionRow = styled.div`
  width: ${(props) => (props.academy ? "935px" : "100%")};
  display: flex;
  justify-content: ${(props) =>
    props.products ? "flex-start" : "space-between"};
  flex-direction: row;
  gap: 20px;
  margin-bottom: 40px;
  align-items: center;
  flex-wrap: wrap;
`;

export const RecomendedProductsCard = styled.div`
  flex: 1 1 0;
  min-width: 140px;
  max-width: 278px;
  max-height: 140px;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  border-radius: 6px;
  padding: 5px 14px 0;
  border: 1px solid rgba(244, 244, 245, 1);
  background: #fff;
`;

export const CardTitle = styled.div`
  text-align: left;
  font-family: Open Sans;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: rgba(17, 167, 217, 1);

  overflow: hidden;
  text-overflow: ellipsis;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  word-break: break-word;
`;

export const AcademyTitle = styled.h3`
  font-family: Aleo;
  font-weight: 600;
  font-size: 38px;
  line-height: 46px;
  color: rgba(0, 34, 68, 1);
`;

export const AcademyIcons = styled.img`
  width: 100%;
  max-width: 239px;
  height: auto;
`;

export const RecomendedProvidersContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const RecomendedProvidersCard = styled.div`
  width: 100%;
  min-height: 90px;
  border-radius: 4px;
  padding: 8px;
  border: 1px solid rgba(228, 228, 231, 1);
  display: flex;
  gap: 20px;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;
`;

export const UserBox = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(230, 244, 255, 1);
  flex-shrink: 0;
`;

export const ProviderCardContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  gap: 8px;
`;

export const LocalizationLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
  font-family: Open Sans;
  font-weight: 400;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
`;

export const ServicesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

export const ProviderInfo = styled.div`
  width: fit-content;
  display: inline-block;
  height: 22px;
  border-radius: 4px;
  border: 1px solid rgba(228, 228, 231, 1);
  background: rgba(0, 0, 0, 0.02);
  font-size: 12px;
  padding-inline: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const PopoverFocus = styled.div`
  width: 30px;
  height: 22px;
  border-radius: 4px;
  background: rgba(230, 244, 255, 1);
  border: 1px solid rgba(153, 217, 239, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Open Sans;
  font-weight: 400;
  font-size: 12px;

  color: rgba(17, 167, 217, 1);
`;

export const PopoverContent = styled.div`
  display: flex;
  gap: 8px;
`;

export const DrawerContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
`;

export const DrawerLabel = styled.div`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 16px;

  color: rgba(17, 167, 217, 1);
`;

export const ProviderInfoContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
`;

export const NoticeCard = styled.div`
  width: 100%;
  min-height: 78px;
  margin-top: 16px;
  border-radius: 6px;
  background: rgba(230, 244, 255, 1);
  border: 1px solid rgba(153, 217, 239, 1);
  display: flex;
  align-items: flex-start;
  padding: 15px;
`;

export const NoticeCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 12px;
`;

export const NavigationButton = styled.div`
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-radius: 6px;
  background: rgba(17, 167, 217, 1);
  color: white;
  cursor: pointer;
  margin-top: auto;

  &:hover {
    background: rgba(17, 167, 217, 0.8);
  }
`;

export const FlagContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const FlagImage = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 100%;
`;

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-family: Open Sans;
  font-weight: 400;
  font-size: 12px;

  background: ${(props) => {
    switch (props.variant) {
      case "concluded":
        return "rgba(246, 255, 237, 1)";
      case "delayed":
        return "rgba(255, 241, 240, 1)";
      default:
        return "rgba(0, 0, 0, 0.02)";
    }
  }};

  color: ${(props) => {
    switch (props.variant) {
      case "concluded":
        return "rgba(82, 196, 26, 1)";
      case "delayed":
        return "rgba(245, 34, 45, 1)";
      default:
        return "rgba(0, 0, 0, 0.88)";
    }
  }};

  border: ${(props) => {
    switch (props.variant) {
      case "concluded":
        return "1px solid rgba(183, 235, 143, 1)";
      case "delayed":
        return "1px solid rgba(255, 163, 158, 1)";
      default:
        return "1px solid rgba(228, 228, 231, 1)";
    }
  }};
`;
